'use client';

import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useSearchParams, useRouter } from 'next/navigation';

export default function HoldExpiredToastClient() {
  const { toast } = useToast();
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    const flag = searchParams.get('holdExpired');
    if (flag === '1') {
      toast({
        title: 'Your hold on this item has expired',
      });
      const newParams = new URLSearchParams(Array.from(searchParams.entries()));
      newParams.delete('holdExpired');
      router.replace(`/?${newParams.toString()}`);
    }
  }, [searchParams, toast, router]);

  return null;
}


